import { Query } from '../../../hooks/queries'
import { useContrastQuery } from '../../../hooks/use-contrast-query'
import { ThisConnector } from '../../../api/connector'
import {
  SeverityVulnData,
  StatusVulnData,
  TypeVulnData
} from '../server-overview-vulnerability'

export interface ServerOverviewVulnerabilityProps {
  assessServer?: boolean
  lastUpdatedTimestamp?: number
  orgUuid: string
  serverId: number
  violations?: []
  vulnCount?: number
}

interface Args {
  dropdownValueType: string
  orgUuid: string
  serverId: number
}

interface ServerVulnResponse {
  message: string[]
  success: boolean
  total_vulnerabilities: number
  traces_breakdown: SeverityVulnData[] | StatusVulnData[] | TypeVulnData[]
}

function query(this: ThisConnector, { orgUuid, serverId, dropdownValueType }) {
  const response = this.connector.get(
    `/${orgUuid}/servers/${serverId}/breakdown/trace/${
      dropdownValueType === 'type' ? 'rule' : dropdownValueType
    }`
  )

  return response
}

export const useServerVulnInfo = ({
  orgUuid,
  serverId,
  dropdownValueType
}: Args) => {
  const { isLoading, error, data } = useContrastQuery<Args, ServerVulnResponse>(
    [Query.APPLICATION_SEARCH_FILTER, orgUuid, serverId, dropdownValueType],
    query,
    {
      orgUuid,
      serverId,
      dropdownValueType
    },
    { cacheTime: 0 }
  )

  return {
    isLoading,
    error,
    data
  }
}
